import React from 'react';
import PropTypes from 'prop-types';
import ListEmpty from '../ListEmpty';
import ListSkeleton from '../ListSkeleton';
import Pagination from '../Pagination';

const List = ({
  list,
  coloums,
  listKey,
  emptyProps,
  showSkeleton,
  skeleton,
  paginationProps,
  RenderComponent,
}) => {
  if (showSkeleton) {
    return <ListSkeleton coloums={coloums} skeleton={skeleton} />;
  }

  if (list && list.length === 0) {
    return <ListEmpty {...(emptyProps || {})} />;
  }

  return (
    <div className="member-center__list">
      <div className="member-center__list-mobile">
        {list.map((item) => {
          return (
            <div
              className="member-center__list-mobile-item"
              key={item[listKey]}
            >
              {coloums.map((coloumItem) => {
                if (Array.isArray(coloumItem)) {
                  return (
                    <div
                      key={coloumItem[0].key || coloumItem[0].id}
                      className="member-center__list-mobile-item-option group"
                    >
                      {coloumItem.map((option, index) => {
                        const { id, key } = option;
                        return (
                          <div
                            className={`member-center__list-mobile-item-option-${
                              index === 0 ? 'left' : 'right'
                            }`}
                            key={key || id}
                          >
                            <RenderComponent
                              id={id}
                              coloum={option}
                              item={item}
                            />
                          </div>
                        );
                      })}
                    </div>
                  );
                } else {
                  const { mobileShow, id, key, title } = coloumItem;
                  if (mobileShow === false) {
                    return null;
                  }
                  return (
                    <div
                      key={key || id}
                      className="member-center__list-mobile-item-option"
                    >
                      <div className="member-center__list-mobile-item-option-left">
                        {title}
                      </div>
                      <div className="member-center__list-mobile-item-option-right">
                        <RenderComponent
                          id={id}
                          coloum={coloumItem}
                          item={item}
                        />
                      </div>
                    </div>
                  );
                }
              })}
            </div>
          );
        })}
      </div>
      <table>
        <thead>
          <tr>
            {coloums.map((item) => {
              if (Array.isArray(item)) {
                return null;
              }
              const { id, key, title, width } = item;
              return (
                <th key={key || id || title} width={width}>
                  {title}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {list.map((item) => {
            return (
              <tr key={item[listKey]}>
                {coloums.map((coloumItem) => {
                  if (coloumItem instanceof Array) {
                    return null;
                  }
                  const { id, key } = coloumItem;
                  return (
                    <td key={key || id}>
                      <RenderComponent
                        id={id}
                        coloum={coloumItem}
                        item={item}
                      />
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      {paginationProps && <Pagination {...paginationProps} />}
    </div>
  );
};

List.propTypes = {
  listKey: PropTypes.string.isRequired,
  list: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.null,
  ]),
  coloums: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.object,

      PropTypes.arrayOf(PropTypes.object),
    ]),
  ),
  emptyProps: PropTypes.shape(ListEmpty.propTypes),
  showSkeleton: PropTypes.bool,
  skeleton: ListSkeleton.propTypes.skeleton,
  paginationProps: PropTypes.shape(Pagination.propTypes),
  RenderComponent: PropTypes.func.isRequired,
};

export default List;
